import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { map } from 'rxjs/operators';
import { Globals } from '../../globals';
import { Installer, UserImp } from '../users/users.interfaces';
import { CreateCustomer } from './installers.interfaces';

@Injectable({
  providedIn: 'root',
})
export class InstallersService {
  private readonly http = inject(HttpClient);
  private readonly globals = inject(Globals);


  getCustomers(installerId: number): Observable<UserImp[]> {
    const url = `${this.globals.apiRoot}/JwtInstallers/${installerId}/customers`;
    return this.http
      .get<UserImp[]>(url)
      .pipe(
        map((data) => data.map((item) => Object.assign(new UserImp(), item)))
      );
  }

  addCustomer(
    installerId: number,
    customer: CreateCustomer
  ): Observable<number> {
    const url = `${this.globals.apiRoot}/JwtInstallers/${installerId}/customers`;
    return this.http.post<number>(url, customer);
  }

  /**
   * Get installer by id
   * @param id Installer id
   */
  getInstaller(id: number): Observable<Installer> {
    const url = `${this.globals.apiRoot}/jwtInstallers/${id}`;
    return this.http.get<Installer>(url);
  }

  /**
   * Get installer code by id
   * @param id Installer id
   */
  getInstallerCode(id: number): Observable<string> {
    const url = `${this.globals.apiRoot}/jwtInstallers/${id}/code`;
    return this.http.get<string>(url);
  }

  /**
   * Update installer data
   * @param installer Installer object
   */
  updateInstaller(installer: Installer): Observable<void> {
    const url = `${this.globals.apiRoot}/jwtInstallers/${installer.id}`;
    return this.http.put<void>(url, installer);
  }
}
